// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content ion-item {
  padding-left: 0;
}
ion-content .ol-status {
  padding-left: 5px;
  padding-right: 5px;
  margin: 0;
  overflow-x: auto;
  white-space: nowrap;
}
ion-content .ol-status li {
  text-align: center;
  display: inline-block;
  margin: 5px;
  padding: 15px;
  background-color: white;
}
ion-content .ol-status li.completed {
  color: white;
  background: #1dad94;
}
ion-content .equipment-status-badge {
  float: right;
}
ion-content ion-button {
  margin-top: 10px;
  margin-bottom: 10px;
}
ion-content div.notify-bottoms-group {
  text-align: center;
}

.history-list ion-item {
  font-size: 12px;
}

.equipment-status {
  background-color: var(--grey-bg-color);
}

.equipment-status.new-pending-approval {
  background-color: var(--dark-blue-bg);
}

.equipment-status.updated-pending-approval {
  background-color: var(--dark-blue-bg);
}

.history-list-item-content {
  width: 100%;
}

.history-list-item-type {
  text-align: center;
  background-color: var(--dark-blue-bg);
  color: white;
}

.history-list-item-user-name, .history-list-item-created {
  font-size: 16px;
}

.history-list-item-value, .history-list-item-sent-from, .history-list-item-sent-to {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/recommendation/recommendation-edit/recommendation-edit.page.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/pages/recommendation/recommendation-edit/recommendation-edit.page.scss"],"names":[],"mappings":"AACE;EACE,eAAA;ACAJ;ADGE;EACE,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;ACDJ;ADGI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;ACDN;ADII;EACE,YAAA;EACA,mBAAA;ACFN;ADME;EACE,YAAA;ACJJ;ADOE;EACE,gBAAA;EACA,mBAAA;ACLJ;ADQE;EACE,kBAAA;ACNJ;;ADUA;EACE,eAAA;ACPF;;ADUA;EACE,sCAAA;ACPF;;ADUA;EACE,qCAAA;ACPF;;ADUA;EACE,qCAAA;ACPF;;ADUA;EACE,WAAA;ACPF;;ADUA;EACE,kBAAA;EACA,qCAAA;EACA,YAAA;ACPF;;ADUA;EACE,eAAA;ACPF;;ADUA;EACE,eAAA;ACPF","sourcesContent":["ion-content {\r\n  ion-item {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .ol-status {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    margin: 0;\r\n    overflow-x: auto;\r\n    white-space: nowrap;\r\n\r\n    li {\r\n      text-align: center;\r\n      display: inline-block;\r\n      margin: 5px;\r\n      padding: 15px;\r\n      background-color: white;\r\n    }\r\n\r\n    li.completed {\r\n      color: white;\r\n      background: #1dad94;\r\n    }\r\n  }\r\n\r\n  .equipment-status-badge {\r\n    float: right;\r\n  }\r\n\r\n  ion-button {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  div.notify-bottoms-group {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.history-list ion-item {\r\n  font-size: 12px;\r\n}\r\n\r\n.equipment-status {\r\n  background-color: var(--grey-bg-color);\r\n}\r\n\r\n.equipment-status.new-pending-approval {\r\n  background-color: var(--dark-blue-bg);\r\n}\r\n\r\n.equipment-status.updated-pending-approval {\r\n  background-color: var(--dark-blue-bg);\r\n}\r\n\r\n.history-list-item-content {\r\n  width: 100%;\r\n}\r\n\r\n.history-list-item-type {\r\n  text-align: center;\r\n  background-color: var(--dark-blue-bg);\r\n  color: white;\r\n}\r\n\r\n.history-list-item-user-name, .history-list-item-created {\r\n  font-size: 16px;\r\n}\r\n\r\n.history-list-item-value, .history-list-item-sent-from, .history-list-item-sent-to {\r\n  font-size: 14px;\r\n}","ion-content ion-item {\n  padding-left: 0;\n}\nion-content .ol-status {\n  padding-left: 5px;\n  padding-right: 5px;\n  margin: 0;\n  overflow-x: auto;\n  white-space: nowrap;\n}\nion-content .ol-status li {\n  text-align: center;\n  display: inline-block;\n  margin: 5px;\n  padding: 15px;\n  background-color: white;\n}\nion-content .ol-status li.completed {\n  color: white;\n  background: #1dad94;\n}\nion-content .equipment-status-badge {\n  float: right;\n}\nion-content ion-button {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nion-content div.notify-bottoms-group {\n  text-align: center;\n}\n\n.history-list ion-item {\n  font-size: 12px;\n}\n\n.equipment-status {\n  background-color: var(--grey-bg-color);\n}\n\n.equipment-status.new-pending-approval {\n  background-color: var(--dark-blue-bg);\n}\n\n.equipment-status.updated-pending-approval {\n  background-color: var(--dark-blue-bg);\n}\n\n.history-list-item-content {\n  width: 100%;\n}\n\n.history-list-item-type {\n  text-align: center;\n  background-color: var(--dark-blue-bg);\n  color: white;\n}\n\n.history-list-item-user-name, .history-list-item-created {\n  font-size: 16px;\n}\n\n.history-list-item-value, .history-list-item-sent-from, .history-list-item-sent-to {\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
